<template>
	<h3 class="font-open-sans text-xl font-bold tracking-tight text-gray-900">
		<slot />
	</h3>
</template>
